/**
 * Webpack resolves the URLs of emitted assets (fonts, images) against `output.publicPath`, which
 * defaults to an empty string. That makes them relative to the *hosting page* instead of to the
 * server the bundle was loaded from, so when the client is embedded in another website they are
 * requested from the wrong host (e.g. https://example.com/some-page/static/smart-icons.woff2).
 *
 * Derive the public path from the URL this bundle was loaded from instead. The bundle is emitted
 * to `<server>/app/` while assets go to `<server>/static/`, so the public path is the directory
 * above the script. A `publicPath` passed at build time always takes precedence.
 *
 * This module must stay the first entry, so it runs before any module that resolves an asset URL.
 */
/* global PUBLIC_PATH, __webpack_public_path__ */

// Matches the `app/graphileon.[name]-[version].js` files this build emits.
const BUNDLE_PATTERN = /\/app\/graphileon\.[^/]+\.js(?:[?#]|$)/;

function getBundleUrl() {
	if (typeof document === 'undefined') {
		return null;
	}

	// While a classic script executes, `currentScript` is that script itself.
	const current = document.currentScript;
	if (current && current.src) {
		return current.src;
	}

	// Deferred, async and dynamically injected scripts leave `currentScript` empty; find ours back
	// by name. Search backwards: the running bundle is the last one added to the page.
	const scripts = document.getElementsByTagName('script');
	for (let i = scripts.length - 1; i >= 0; i--) {
		const src = scripts[i].src;
		if (src && BUNDLE_PATTERN.test(src)) {
			return src;
		}
	}

	return null;
}

if (typeof PUBLIC_PATH === 'undefined' || ! PUBLIC_PATH) {
	const bundleUrl = getBundleUrl();
	if (bundleUrl) {
		try {
			// `<server>/app/graphileon.main-1.2.3.js` -> `<server>/`
			__webpack_public_path__ = new URL('../', bundleUrl).href;
		} catch (e) {
			// Leave the build-time public path in place if the URL cannot be resolved.
		}
	}
}
